import React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

export const PhoneNumberMask = React.forwardRef(
  ({ name, onChange, ...props }, ref) => (
    <IMaskInput
      {...props}
      mask="(###) ###-####"
      definitions={{ '#': /[0-9]/ }}
      inputRef={ref}
      onAccept={(value, _, event) => {
        // event is only truthy if a user actively typed otherwise undefined.
        if (event) {
          onChange(value);
        }
      }}
      overwrite
    />
  ),
);

PhoneNumberMask.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};
